import React from "react";
import { Pill, LiveDot, Tick, ButtonPrimary, ButtonGhost } from "./ui";

const BOOK_URL = "https://bookings.cloud.microsoft/book/EkkBazInvestment@EkkBaz.com/?ismsaljsauthenabled";

export default function FinalCta() {
  return (
    <section id="book" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-[32px] border border-white/[0.08] bg-gradient-to-br from-[#0b1535] via-[#08102d] to-[#050a1f] p-10 lg:p-16">
          <div aria-hidden="true" className="pointer-events-none absolute -top-32 -right-24 h-[440px] w-[440px] rounded-full blur-[120px] opacity-50"
               style={{ background: "radial-gradient(closest-side, rgba(94,234,212,0.45), transparent 70%)" }} />
          <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-grid-faint opacity-50" />

          <div className="relative grid items-center gap-10 lg:grid-cols-[1.3fr,1fr]">
            <div>
              <Pill tone="accent"><LiveDot /> &nbsp; 30-min strategy call · no slideware</Pill>
              <h2 className="mt-5 text-[40px] leading-[1.02] tracking-tight sm:text-[52px] lg:text-[64px]">
                <span className="text-white">Pick one workflow.</span><br />
                <span className="font-display italic grad-text">We&rsquo;ll prove it in six weeks.</span>
              </h2>
              <p className="mt-5 max-w-xl text-[16.5px] text-white/65">
                Book a working session with our AI architects. We map your highest-leverage workflow live, design the agent on the call, and send you a costed plan within 48 hours.
              </p>
              <div className="mt-8 flex flex-wrap items-center gap-3">
                <ButtonPrimary href={BOOK_URL} external>Book strategy call</ButtonPrimary>
                <ButtonGhost href="#demo">Watch a live agent run</ButtonGhost>
              </div>
              <div className="mt-8 grid grid-cols-2 gap-x-6 gap-y-2 text-[12.5px] text-white/55 sm:grid-cols-3">
                <span className="flex items-center gap-2"><Tick /> First agent live in 6 weeks</span>
                <span className="flex items-center gap-2"><Tick /> KPI-or-don&rsquo;t-pay clause</span>
                <span className="flex items-center gap-2"><Tick /> SOC 2 · ISO 27001 aligned</span>
                <span className="flex items-center gap-2"><Tick /> Your data, your IP</span>
                <span className="flex items-center gap-2"><Tick /> Outcome-linked pricing</span>
                <span className="flex items-center gap-2"><Tick /> Private deploy option</span>
              </div>
            </div>

            <div className="rounded-2xl border border-white/[0.1] bg-white/[0.04] p-6 backdrop-blur">
              <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-cyan-300/80">Next available</div>
              <div className="mt-2 text-[22px] font-semibold text-white">This Thursday · 11:00 SGT</div>
              <div className="mt-1 text-[13px] text-white/50">Or pick another slot — we keep mornings open.</div>
              <div className="mt-5 space-y-3">
                {["30 minutes · video", "Real AI architect, not BDR", "Costed plan in your inbox in 48h"].map(x => (
                  <div key={x} className="flex items-center gap-3 rounded-lg border border-white/[0.06] bg-[#070d24] px-3 py-2.5 text-[13px] text-white/80">
                    <Tick />{x}
                  </div>
                ))}
              </div>
              <a href={BOOK_URL} target="_blank" rel="noopener noreferrer" className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-full bg-white px-5 py-3 text-[14px] font-semibold text-[#051030] hover:-translate-y-0.5">
                Reserve my slot
                <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"><path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" /></svg>
              </a>
              <div className="mt-3 text-center text-[11px] text-white/40">No follow-up spam · we send one summary, then stop.</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
